import React from 'react'
import PropTypes from 'prop-types'
import * as api from './notesApi'
import sessionStore from "../../services/session/SessionStore";

/**
 * data component. Fetches and keeps note state for an entityId. Fairly naive
 * (doesn't keep track of note saving statuses, or any kind of error tracking)
 * passes through the following props to its render component
 * onSave: {function{
 * onDelete: {function},
 * notes: Array<{{*}}>
 * isLoading: boolean
 */
export class WithNoteData extends React.Component {

  static propTypes = {
    noteType: PropTypes.string.isRequired,
    entityId: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.string).isRequired,
    render: PropTypes.func.isRequired
  }

  static defaultProps = {
    filters: []
  }

  state = {
    isLoading: false,
    notes: [],
    /*noteAdmin: sessionStore.user.permissions.indexOf('NoteAdmin') >= 0*/
  }

  componentDidMount() {
    try {
      // TODO - also get alternate note ids / types for legacy patterns (e.g. DuplicateListings type with duplicate listing's id)
      api.getNotes({ids: [this.props.entityId], noteType: this.props.noteType})
        .then(notes => {
          /*const visibleNotes = notes.filter(note => this.visible(note))*/
          this.setState({isLoading: false, notes: notes})
        })
    } catch (e) {
      console.error('notes fail', e)
    }
  }

  componentWillReceiveProps(nextProps, _) {
    if (nextProps.noteType !== this.props.noteType || nextProps.entityId !== this.props.entityId) {
      throw new Error('NoteData props noteType and entityId are expected to be immutable')
    }
  }

  /*visible = note => note.visibility === 'Admin' && this.state.noteAdmin || note.visibility === 'Standard'*/

  onSave = (note) => {
    if (note._id) {
      const noteId = note._id
      api.updateNote({
        noteId,
        ...note
      }).then(resp => {
        // update data
        this.setState({ notes: this.state.notes.map(eachNote => {
            return eachNote._id === noteId ? note : eachNote
          })})
      })


    } else {
      api.addNote({
        ...note,
        noteType: this.props.noteType,
        entityId: this.props.entityId,
        filters: this.props.filters.length ? this.props.filters : undefined
      }).then(added => {
        this.setState({ notes: this.state.notes.concat([added])})
      })
    }
  }

  onDelete = (note) => {
    api.deleteNote(note._id).then(() => {
      this.setState({ notes: this.state.notes.filter(eachNote => {
        return eachNote._id !== note._id
      })})
    })
  }

  render() {
    const {noteType, entityId, render, ...props} = this.props
    const {onSave, onDelete} = this
    const {isLoading, notes} = this.state
    return this.props.render({
      notes,
      isLoading,
      onSave,
      onDelete,
      ...props})
  }


}